<template>
  <a-modal v-model:visible="coverVisible" @ok="handleOk" :width="700">
    <template #title>
      <div class="df">
        <div class="orange"><InfoCircleOutlined />&nbsp;&nbsp;</div>
        <div>确定要覆盖下列展示数据？</div>
      </div>
    </template>
    <a-table
      :dataSource="coverDataSource"
      :columns="columns"
      :scroll="{ x: 1530 }"
      :pagination="false"
      @resizeColumn="handleResizeColumn"
      class="mb40"
    >
      <template #category1="{ record }">
        <a-tooltip>
          <template #title>{{
            record.positions.filter(v => v.position - 0 === 1)[0].categoryName
          }}</template>
          <div class="list-ellipsis">
            {{
              record.positions.filter(v => v.position - 0 === 1)[0].categoryName
            }}
          </div>
        </a-tooltip>
      </template>
      <template #category2="{ record }">
        <a-tooltip>
          <template #title>{{
            record.positions.filter(v => v.position - 0 === 2)[0].categoryName
          }}</template>
          <div class="list-ellipsis">
            {{
              record.positions.filter(v => v.position - 0 === 2)[0].categoryName
            }}
          </div>
        </a-tooltip>
      </template>
      <template #category3="{ record }">
        <a-tooltip>
          <template #title>{{
            record.positions.filter(v => v.position - 0 === 3)[0].categoryName
          }}</template>
          <div class="list-ellipsis">
            {{
              record.positions.filter(v => v.position - 0 === 3)[0].categoryName
            }}
          </div>
        </a-tooltip>
      </template>
      <template #category4="{ record }">
        <a-tooltip>
          <template #title>{{
            record.positions.filter(v => v.position - 0 === 4)[0].categoryName
          }}</template>
          <div class="list-ellipsis">
            {{
              record.positions.filter(v => v.position - 0 === 4)[0].categoryName
            }}
          </div>
        </a-tooltip>
      </template>
      <template #category5="{ record }">
        <a-tooltip>
          <template #title>{{
            record.positions.filter(v => v.position - 0 === 5)[0].categoryName
          }}</template>
          <div class="list-ellipsis">
            {{
              record.positions.filter(v => v.position - 0 === 5)[0].categoryName
            }}
          </div>
        </a-tooltip>
      </template>
    </a-table>
    <template #footer>
      <div>
        <a-button type="default" @click="() => changeCoverVisible(false)"
          >取消</a-button
        >
        <a-button type="primary" @click="save">确定</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    InfoCircleOutlined
  },
  setup() {
    const columns = ref([
      {
        title: '站点',
        dataIndex: 'siteName',
        key: 'siteName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '终端',
        dataIndex: 'terminalName',
        key: 'terminalName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '月份',
        dataIndex: 'month',
        key: 'month',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '主商品二级类目',
        dataIndex: 'mainSkcCategoryName',
        key: 'mainSkcCategoryName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '坑1',
        dataIndex: 'category1',
        slots: { customRender: 'category1' },
        width: 200,
        resizable: true,
        align: 'center'
      },
      {
        title: '坑2',
        dataIndex: 'category2',
        slots: { customRender: 'category2' },
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '坑3',
        slots: { customRender: 'category3' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '坑4',
        slots: { customRender: 'category4' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '坑5',
        slots: { customRender: 'category5' },
        key: 'name',
        align: 'center',
        width: 200
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.list-ellipsis {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orange {
  color: orange;
}
</style>
